export default __webpack_public_path__ + "static/media/deck_hd.eae3b993.webp";